import { render, staticRenderFns } from "./CountryItem.vue?vue&type=template&id=0d439fe6&scoped=true&"
import script from "./CountryItem.vue?vue&type=script&lang=ts&"
export * from "./CountryItem.vue?vue&type=script&lang=ts&"
import style0 from "./CountryItem.vue?vue&type=style&index=0&id=0d439fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d439fe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d439fe6')) {
      api.createRecord('0d439fe6', component.options)
    } else {
      api.reload('0d439fe6', component.options)
    }
    module.hot.accept("./CountryItem.vue?vue&type=template&id=0d439fe6&scoped=true&", function () {
      api.rerender('0d439fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/CountryItem.vue"
export default component.exports